import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { addDays } from "date-fns";

function DeliveryDatePicker({ onDateChange }) {
    const [selectedDate, setSelectedDate] = useState(null);

    const handleDateChange = (date) => {
        setSelectedDate(date);
        if (onDateChange) {
            onDateChange(date);
        }
    };

    return (
        <div className="d-flex flex-row flex-sm-column px-2 py-1">
            <label className="me-auto my-auto" htmlFor="delivery-date">Select Pickup/Delivery Date:</label>
            <DatePicker
                id="delivery-date"
                selected={selectedDate}
                onChange={handleDateChange}
                minDate={addDays(new Date(), 3)} // Only allow 2+ days in advance
                dateFormat="yyyy-MM-dd"
                className="form-control text-dark"
                placeholderText="Choose a delivery date"
                required
            />
        </div>  
    );
}

export default DeliveryDatePicker;
